import { useStaffStream } from './useStaffStream'

/**
 * Subscribes the Admin dashboard to the live event feed.
 *
 * Slide 23 promises the Committee "sees the whole event in real time". The
 * server pushes the whole dashboard on connect and again whenever a booth
 * scans, a judge saves a mark or a sheet is submitted, so nothing is polled.
 *
 * The connection mechanics are in `useStaffStream`, shared with the judges'
 * tie-break stream.
 */
export function useAdminStream<T>(enabled: boolean) {
  return useStaffStream<T>({
    ticketPath: '/api/admin/stream-ticket',
    streamPath: '/api/admin/stream',
    eventName: 'dashboard',
    enabled,
  })
}
